"use client";

import { useState, useEffect } from "react";

export default function FadeTransition({ show, children }) {
  const [shouldRender, setShouldRender] = useState(show);

  useEffect(() => {
    if (show) setShouldRender(true);
    const timer = setTimeout(() => {
      if (!show) setShouldRender(false);
    }, 300); // Match this with the CSS transition duration
    return () => clearTimeout(timer);
  }, [show]);

  if (!shouldRender) return null;

  return (
    <div
      className={`transition-opacity duration-300 ${
        show ? "opacity-100" : "opacity-0"
      }`}
    >
      {children}
    </div>
  );
}
